<style>
  tr:hover td {
      background-color: #3F51B5;
  }
    .unsubscribedColor {color: #E91E63 !important;}
    .problemColor {color: #e9d81e !important;}
    .subscribedColor {color: #0f9e3e !important;}

</style>
<template>
  <div>
	<h1 class="page-header mb-3">Calendar Admin</h1>
  <div class="row">
      <div class="col-xl-12">
        <div class="card border-0 mb-3 overflow-hidden bg-gray-800 text-white">
          <div class="card-body">
            <div v-if="loading" class="loading text-center"><div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div></div>
            <vue-good-table
              :columns="columns"
              v-if="rows && rows.length"
                :rows="rows"
              :lineNumbers="false"
              :search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Search Current Table' }"
              :pagination-options="{ enabled: true,  position: 'bottom', perPage: 20, mode: 'pages' }"
              :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: true,
                selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
                :sort-options="{
                enabled: false,
                multipleColumns: true,
                initialSortBy: [{field: 'build_date', type: 'desc'}]
              }"
              @on-cell-click="onCellClick"
            >
              <div slot="table-actions">
                <button class="btn btn-primary ms-2 fw-bold" @click="checkSubscriptions">Check Subscriptions <span class="fa fa-refresh"></span></button>
                <button class="btn btn-info ms-2 fw-bold" @click="checkAllGoogleStatus">Check All Calendars <span class="fa fa-calendar-check"></span></button>
                <!-- <button class="btn btn-primary ms-2 fw-bold" @click="fetchCalendarData">REFRESH <span class="fa fa-refresh"></span></button> -->
              </div>
              <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'google_last_event'">
                    <span v-if="props.row.google_loading" class="spinner-border spinner-border-sm text-primary" role="status"></span>
                    <span v-else-if="props.row.google_last_event">{{ props.row.google_last_event }}</span>
                    <span v-else>
                      <button class="btn btn-sm btn-outline-info me-1" @click.stop="checkGoogleStatus(props.row)">Check</button>
                      <button class="btn btn-sm btn-outline-secondary" @click.stop="checkEventCount(props.row)">Count</button>
                    </span>
                  </span>
                  <span v-else-if="props.column.field === 'actions'">
                    <span v-if="props.row.rebuild_loading" class="spinner-border spinner-border-sm text-warning" role="status"></span>
                    <span v-else-if="props.row.rebuild_status" :class="props.row.rebuild_status === 'Done' || props.row.rebuild_status === 'Cleared' ? 'text-success' : 'text-danger'">{{ props.row.rebuild_status }}</span>
                    <span v-else>
                      <button class="btn btn-sm btn-outline-warning me-1" @click.stop="confirmRebuild(props.row)">Rebuild</button>
                      <button class="btn btn-sm btn-outline-danger me-1" @click.stop="confirmClear(props.row)">Clear</button>
                      <button class="btn btn-sm btn-outline-secondary" @click.stop="confirmRecreate(props.row)">Recreate</button>
                    </span>
                  </span>
                  <span v-else>{{props.formattedRow[props.column.field]}}</span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import moment from 'moment';
//import AppOptions from '../config/AppOptions.vue';
import axios from 'axios';
import { useCookies } from "vue3-cookies";


export default {
  name: 'calendardash',
    setup() {
      const { cookies } = useCookies();
      return { cookies };
    },
    data()
    {
      return {
        loading: false,
        columns: [
          {
            label: 'Name',
            field: 'user_name',
            thClass: 'text-nowrap',
            tdClass: this.getSubscriptionColor,
          },
          {
            label: 'Gmail',
            field: 'gmail',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap'
          },
          {
            label: 'WP Login',
            field: 'user_login',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap'
          },
          {
            label: 'Birth Date',
            field: 'birth_date',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap',
            formatFn: this.formatDateInt,
          },
          {
            label: 'Build Date',
            field: 'build_date',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap',
            formatFn: this.formatDateInt,
          },
          {
            label: 'Calendar ID',
            field: 'calendar_id',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap',
            formatFn: function (value)
            {
              return value.replace('@group.calendar.google.com', '');
            }
          },
          {
            label: 'Last Update',
            field: 'last_date',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap',
            formatFn: this.formatDateInt,
          },
          {
            label: 'Google Last Event',
            field: 'google_last_event',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap',
          },
          {
            label: 'Actions',
            field: 'actions',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap',
            sortable: false,
          }
        ],
        rows: null,
      }
    },
    methods: {
      fetchCalendarData()
      {
        this.error = null;
        this.loading = true;

        axios
          .post('https://api.destinycards.com/v1/reportadmin/calendar/list')
          .then(response => {
              this.rows = response.data.data;
              this.loading = false;
              //this.checkSubscriptions();
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      },
      async checkSubscriptions() {
        this.loading = true;
        for (let index = 0; index < this.rows.length; index++) {
          const row = this.rows[index];
          const result = await this.hasCalendarSubscription(index, row.wpid);
          await this.updateRowSubscription(index, result);
          // Small delay to avoid triggering rate limiting
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        this.loading = false;
      },
      async updateRowSubscription(index, active)
      {
          return axios
          .post('https://api.destinycards.com/v1/reportadmin/calendar/updateSubscription', {
            id: this.rows[index].wpid,
            active: active
          })
          .catch(error => {
            console.log(error);
          });
      },
      async hasCalendarSubscription(index, wpid)
      {
          const consumer_key = 'ck_52c9813975f8009ccbdde4aef6e1a37f9a8d782f';
          const consumer_secret = 'cs_06ce8b9db636718f5ac34cd8c36a177fdc80328e';
          const url = `https://www.cardsofyourdestiny.com/wp-json/wc/v3/subscriptions?customer=${wpid}`;
          const productId = 38309;

          try
          {
                const response = await axios.get(url, {
                    auth: {
                        username: consumer_key,
                        password: consumer_secret,
                    },
                });

                const subscriptions = response.data;

                // Check all subscriptions for product, prioritize active status
                let bestStatus = null;
                for (let subscription of subscriptions) {
                    for (let item of subscription.line_items) {
                        if (item.product_id == productId) {
                          switch (subscription.status)
                          {
                            case 'active': return 1; // found active, no need to check further
                            case 'on-hold':
                            case 'pending-cancel':
                              bestStatus = 2; break;
                            case 'cancelled':
                            case 'expired':
                              if (bestStatus === null) bestStatus = 0; break;
                          }
                        }
                    }
                }

                // null = no subscription with this product found at all
                return bestStatus !== null ? bestStatus : 0;

          }
          catch (error)
          {
              console.error(error);
              return 2;
          }
      },
      confirmRecreate(row) {
        if (confirm('RECREATE calendar for ' + row.user_name + '? This deletes the old calendar entirely, creates a new one, and re-shares it. The user will need the new calendar link.')) {
          this.recreateCalendar(row);
        }
      },
      async recreateCalendar(row) {
        this.$set(row, 'rebuild_loading', true);
        try {
          window.open('https://calendar.destinycards.com/recreate/' + row.wpid);
          this.$set(row, 'rebuild_status', 'Recreated - now Rebuild');
          this.$set(row, 'google_last_event', null);
        } catch (error) {
          let serverError = error.response && error.response.data && error.response.data.error ? error.response.data.error : '';
          this.$set(row, 'rebuild_status', 'Recreate failed' + (serverError ? ': ' + serverError : ''));
          console.log(error);
        }
        this.$set(row, 'rebuild_loading', false);
      },
      confirmClear(row) {
        if (confirm('Clear ALL calendar events for ' + row.user_name + '? This cannot be undone.')) {
          this.clearCalendar(row);
        }
      },
      async clearCalendar(row) {
        this.$set(row, 'rebuild_loading', true);
        try {
          // First check if there are any events to clear
          this.$set(row, 'rebuild_status', 'Counting...');
          const countResponse = await axios.get('https://calendar.destinycards.com/count/' + row.wpid);
          let total = countResponse.data.event_count;

          if (total === 0) {
            this.$set(row, 'rebuild_status', 'Cleared (0 events)');
            this.$set(row, 'rebuild_loading', false);
            return;
          }

          let deleted = 0;
          let remaining = true;
          while (remaining) {
            this.$set(row, 'rebuild_status', 'Clearing ' + deleted + '/' + total + '...');
            const response = await axios.get('https://calendar.destinycards.com/clear/' + row.wpid);
            deleted += response.data.cleared;
            remaining = response.data.remaining;
          }
          this.$set(row, 'rebuild_status', 'Cleared');
          this.$set(row, 'google_last_event', null);
        } catch (error) {
          let serverError = error.response && error.response.data && error.response.data.error ? error.response.data.error : '';
          let msg = row.rebuild_status ? row.rebuild_status.replace('...', ' failed') : 'Error';
          if (serverError) msg += ': ' + serverError;
          this.$set(row, 'rebuild_status', msg);
          console.log(error);
        }
        this.$set(row, 'rebuild_loading', false);
      },
      confirmRebuild(row) {
        if (confirm('Rebuild calendar for ' + row.user_name + '? This will generate events from start of current month through next year.')) {
          this.rebuildCalendar(row);
        }
      },
      async rebuildCalendar(row) {
        this.$set(row, 'rebuild_loading', true);
        try {
          // Step 1: Reset last_date so update starts from beginning of current month
          this.$set(row, 'rebuild_status', 'Resetting...');
          await axios.get('https://calendar.destinycards.com/reset/' + row.wpid);

          // Step 2: Loop calling /update in 10-week chunks until fully caught up
          let chunk = 1;
          let complete = false;
          while (!complete) {
            this.$set(row, 'rebuild_status', 'Generating chunk ' + chunk + '...');
            const response = await axios.get('https://calendar.destinycards.com/update/' + row.wpid + '?force=1');
            complete = response.data.complete;
            if (!response.data.updated) break;
            chunk++;
          }

          this.$set(row, 'rebuild_status', 'Done');
          this.$set(row, 'google_last_event', null);
        } catch (error) {
          let serverError = error.response && error.response.data && error.response.data.error ? error.response.data.error : '';
          let msg = row.rebuild_status ? row.rebuild_status.replace('...', ' failed') : 'Error';
          if (serverError) msg += ': ' + serverError;
          this.$set(row, 'rebuild_status', msg);
          console.log(error);
        }
        this.$set(row, 'rebuild_loading', false);
      },
      async checkEventCount(row) {
        this.$set(row, 'google_loading', true);
        try {
          const response = await axios.get('https://calendar.destinycards.com/count/' + row.wpid);
          this.$set(row, 'google_last_event', response.data.event_count + ' events');
        } catch (error) {
          this.$set(row, 'google_last_event', 'Error');
          console.log(error);
        }
        this.$set(row, 'google_loading', false);
      },
      async checkGoogleStatus(row) {
        this.$set(row, 'google_loading', true);
        try {
          const response = await axios.get('https://calendar.destinycards.com/status/' + row.wpid);
          const data = response.data;
          // Format YYYYMMDD to YYYY-MM-DD for display
          let googleDate = data.latest_event_google;
          if (googleDate && googleDate.length === 8) {
            googleDate = googleDate.substring(0, 4) + '-' + googleDate.substring(4, 6) + '-' + googleDate.substring(6, 8);
          }
          this.$set(row, 'google_last_event', googleDate || 'No events');
        } catch (error) {
          this.$set(row, 'google_last_event', 'Error');
          console.log(error);
        }
        this.$set(row, 'google_loading', false);
      },
      async checkAllGoogleStatus() {
        for (let index = 0; index < this.rows.length; index++) {
          const row = this.rows[index];
          if (row.calendar_id) {
            await this.checkGoogleStatus(row);
            await new Promise(resolve => setTimeout(resolve, 300));
          }
        }
      },
      formatDateInt(value) {
        if (!value || value === 0 || value === '0') return '';
        let s = String(value);
        if (s.length === 8) return s.substring(0, 4) + '-' + s.substring(4, 6) + '-' + s.substring(6, 8);
        return s;
      },
      getSubscriptionColor(rowObj)
      {
        switch (rowObj.active)
        {
          case 0: return 'unsubscribedColor';
          case 1: return 'subscribedColor';
          default: return 'problemColor';
        }
        //return rowObj.active ? 'subscribedColor' : 'unsubscribedColor';
      },

      /*
      onRowClick(params) {
        alert('Coming soon.');
        console.log(params);
      },
      */
      async updateCalendar(row) {
        this.$set(row, 'rebuild_loading', true);
        try {
          let chunk = 1;
          let complete = false;
          while (!complete) {
            this.$set(row, 'rebuild_status', 'Updating chunk ' + chunk + '...');
            const response = await axios.get('https://calendar.destinycards.com/update/' + row.wpid + '?force=1');
            complete = response.data.complete;
            if (!response.data.updated) break;
            chunk++;
          }
          this.$set(row, 'rebuild_status', 'Done');
          this.$set(row, 'google_last_event', null);
        } catch (error) {
          let serverError = error.response && error.response.data && error.response.data.error ? error.response.data.error : '';
          this.$set(row, 'rebuild_status', 'Update failed' + (serverError ? ': ' + serverError : ''));
          console.log(error);
        }
        this.$set(row, 'rebuild_loading', false);
      },
      onCellClick(params) {
        let wpid = params.row['wpid'];
        let fieldname = params.column.field;

        switch (fieldname)
        {
          case 'user_login': window.open('https://www.cardsofyourdestiny.com/wp-admin/user-edit.php?user_id=' + wpid); break;
          case 'last_date': this.updateCalendar(params.row); break;
        }
      }
    },
    created() {
      this.fetchCalendarData();
    },
    mounted: function()
    {
      let username = this.cookies.get('username');
      let authenticated = this.cookies.get("authenticated");
      if (username === null || authenticated === null)
      {
        this.$router.push('/user/login-v3');
      }
      else {
        const crypto = require('crypto');
        const secret = 'GASEWkjshga@asdjfhasdfAA!fcaf@gdh#asdA';
        const hash = crypto.createHmac('sha256', secret)
            .update(authenticated)
            .digest('hex');
        if (username !== 'admin' || hash !== 'b8d32bd79ea384bb101f69e0935ee9c87be516c6642e39a479bf417b16354b2e') {
          this.$router.push('/user/login-v3');
        } else {
          this.fetchCalendarData();
        }
      }
    }
	}
</script>